<template>
  <div v-if="isOpen" class="modal-container">
    <!-- Backdrop with blur -->
    <div
      class="fixed inset-0 bg-black/40 backdrop-blur-sm z-[10000] -webkit-backdrop-filter: blur(4px)"
      @click="$emit('close')"
    ></div>

    <!-- Modal Content -->
    <div
      class="relative bg-white dark:bg-card w-full max-w-md m-auto rounded-[24px] shadow-2xl z-[10001] border border-border p-8 flex flex-col gap-6 scale-in"
    >
      <div class="flex flex-col gap-2 text-center">
        <h2 class="text-xl font-bold text-foreground">{{ title }}</h2>
        <p class="text-sm text-muted-foreground leading-relaxed">
          {{ message }}
        </p>
      </div>

      <div class="flex items-center gap-3">
        <button
          @click="$emit('close')"
          class="flex-1 px-4 py-3 border border-border rounded-full text-sm font-bold text-foreground hover:bg-muted transition-colors"
        >
          Cancel
        </button>
        <button
          @click="$emit('confirm')"
          class="flex-1 px-4 py-3 bg-red-500 text-white rounded-full text-sm font-bold hover:bg-red-600 transition-colors shadow-sm"
        >
          Delete
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  isOpen: Boolean,
  title: {
    type: String,
    default: "Delete Note",
  },
  message: {
    type: String,
    default:
      "Are you sure you want to delete this note? This action cannot be undone.",
  },
});

defineEmits(["close", "confirm"]);
</script>

<style scoped>
.modal-container {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 1rem;
}

.scale-in {
  animation: scaleIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
